// English translations, keyed by the Macedonian source text. Split per area so
// they can be edited independently; later files win on duplicate keys.
import common from './en/common';
import invoices from './en/invoices';
import documents from './en/documents';
import catalog from './en/catalog';
import settings from './en/settings';

export default { ...common, ...settings, ...catalog, ...documents, ...invoices };
